import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) { return (_pushScopeId("data-v-75e8742f"), n = n(), _popScopeId(), n); };
var _hoisted_1 = { class: "wrap" };
var _hoisted_2 = { class: "content" };
var _hoisted_3 = { class: "title" };
var _hoisted_4 = /*#__PURE__*/ _createTextVNode("待出库");
var _hoisted_5 = /*#__PURE__*/ _createTextVNode("已出库");
var _hoisted_6 = /*#__PURE__*/ _createTextVNode("已使用");
var _hoisted_7 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("p", { class: "form-title" }, "医院信息", -1); });
var _hoisted_8 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("p", { class: "form-title" }, "患者信息", -1); });
var _hoisted_9 = { class: "btn-box" };
var _hoisted_10 = /*#__PURE__*/ _createTextVNode("出库");
var _hoisted_11 = /*#__PURE__*/ _createTextVNode("回收库存");
var _hoisted_12 = /*#__PURE__*/ _createTextVNode("确定");
import { Field, NavBar, Icon, Tag, Button, Dialog, Toast } from "vant";
import { useRoute, useRouter } from "vue-router";
import { refundSample } from "@/api";
export default /*#__PURE__*/ _defineComponent({
    __name: 'SampleDetails',
    setup: function (__props) {
        var route = useRoute();
        var router = useRouter();
        var orderInfo = route.query;
        // 回收库存
        var handleRecycling = function () {
            Dialog.confirm({
                title: "请确定",
                message: "确定要回收库存？",
            })
                .then(function () {
                refundSample(orderInfo.sampleCode).then(function (res) {
                    if (res.code === 200) {
                        Toast("回库成功！");
                        router.go(-1);
                    }
                    else {
                        Toast(res.message);
                    }
                });
            })
                .catch(function () {
                // on cancel
            });
        };
        // const handleConfirm = () => {
        // }
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_unref(NavBar), {
                    title: "样本详情",
                    onClickLeft: _cache[0] || (_cache[0] = function ($event) { return (_unref(router).go(-1)); })
                }, {
                    left: _withCtx(function () { return [
                        _createVNode(_unref(Icon), {
                            color: "rgba(0,0,0,0.9)",
                            name: "arrow-left",
                            size: "24"
                        })
                    ]; }),
                    _: 1
                }),
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(orderInfo).sampleCode), 1),
                    _createVNode(_unref(Field), {
                        style: _normalizeStyle({ margin: '0.16rem 0' }),
                        label: "出库状态"
                    }, {
                        input: _withCtx(function () { return [
                            (_unref(orderInfo).sampleStatus == 2)
                                ? (_openBlock(), _createBlock(_unref(Tag), {
                                    key: 0,
                                    style: _normalizeStyle({ marginLeft: '0.2rem' }),
                                    type: "warning"
                                }, {
                                    default: _withCtx(function () { return [
                                        _hoisted_4
                                    ]; }),
                                    _: 1
                                }, 8, ["style"]))
                                : _createCommentVNode("", true),
                            (_unref(orderInfo).sampleStatus == 3)
                                ? (_openBlock(), _createBlock(_unref(Tag), {
                                    key: 1,
                                    style: _normalizeStyle({ marginLeft: '0.2rem' }),
                                    type: "success"
                                }, {
                                    default: _withCtx(function () { return [
                                        _hoisted_5
                                    ]; }),
                                    _: 1
                                }, 8, ["style"]))
                                : _createCommentVNode("", true),
                            (_unref(orderInfo).sampleStatus == 4)
                                ? (_openBlock(), _createBlock(_unref(Tag), {
                                    key: 2,
                                    style: _normalizeStyle({ marginLeft: '0.2rem' }),
                                    type: "danger"
                                }, {
                                    default: _withCtx(function () { return [
                                        _hoisted_6
                                    ]; }),
                                    _: 1
                                }, 8, ["style"]))
                                : _createCommentVNode("", true)
                        ]; }),
                        _: 1
                    }, 8, ["style"]),
                    _createVNode(_unref(Field), {
                        "model-value": _unref(orderInfo).refHospitalTime,
                        label: "出库时间",
                        readonly: ""
                    }, null, 8, ["model-value"]),
                    _hoisted_7,
                    _createVNode(_unref(Field), {
                        "model-value": _unref(orderInfo).hospitalName,
                        label: "出库医院",
                        readonly: ""
                    }, null, 8, ["model-value"]),
                    _createVNode(_unref(Field), {
                        "model-value": _unref(orderInfo).hospitalDepartName,
                        label: "科室",
                        readonly: ""
                    }, null, 8, ["model-value"]),
                    _createVNode(_unref(Field), {
                        "model-value": _unref(orderInfo).hospitalDoctorName,
                        label: "医生",
                        readonly: ""
                    }, null, 8, ["model-value"]),
                    _hoisted_8,
                    _createVNode(_unref(Field), {
                        "model-value": _unref(orderInfo).testUserName,
                        name: "受检人",
                        label: "受检人",
                        readonly: ""
                    }, null, 8, ["model-value"]),
                    _createVNode(_unref(Field), {
                        "model-value": _unref(orderInfo).orderCreateTime,
                        label: "下单时间",
                        readonly: ""
                    }, null, 8, ["model-value"]),
                    _createElementVNode("div", _hoisted_9, [
                        (_unref(orderInfo).sampleStatus == 2)
                            ? (_openBlock(), _createBlock(_unref(Button), {
                                key: 0,
                                color: "#3DABA4",
                                size: "large",
                                plain: "",
                                onClick: _cache[1] || (_cache[1] = function ($event) { return (_unref(router).push("/salesman-scan-out?sampleCode=" + _unref(orderInfo).sampleCode)); })
                            }, {
                                default: _withCtx(function () { return [
                                    _hoisted_10
                                ]; }),
                                _: 1
                            }))
                            : _createCommentVNode("", true),
                        (_unref(orderInfo).sampleStatus == 3)
                            ? (_openBlock(), _createBlock(_unref(Button), {
                                key: 1,
                                color: "#3DABA4",
                                size: "large",
                                plain: "",
                                onClick: handleRecycling
                            }, {
                                default: _withCtx(function () { return [
                                    _hoisted_11
                                ]; }),
                                _: 1
                            }))
                            : _createCommentVNode("", true),
                        (_unref(orderInfo).sampleStatus == 4)
                            ? (_openBlock(), _createBlock(_unref(Button), {
                                key: 2,
                                color: "#3DABA4",
                                size: "large",
                                plain: "",
                                onClick: _cache[2] || (_cache[2] = function ($event) { return (_unref(router).push("/salesman-sample-list")); })
                            }, {
                                default: _withCtx(function () { return [
                                    _hoisted_12
                                ]; }),
                                _: 1
                            }))
                            : _createCommentVNode("", true)
                    ])
                ])
            ]));
        };
    }
});
